import React, { FC } from 'react';

import { FeatureFlagProvider } from '@modernloop/shared/feature-flag';

import useAuth from 'src/hooks/useAuth';

import { buildLaunchDarklyUser } from 'src/utils/logger/identifyLaunchDarklyUser';

import { launchDarklyConfig } from 'src/config';

/**
 * Provides the LaunchDarkly-backed feature-flag context for the hiring
 * dashboard. Vendor wiring lives in the shared `FeatureFlagProvider`; this
 * wrapper only supplies the app-specific client id and evaluation context.
 */
const LDProviderWrapper: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { userInfo, isInitialised } = useAuth();

  const userContext = isInitialised ? buildLaunchDarklyUser(userInfo) : undefined;
  return (
    <FeatureFlagProvider clientSideID={launchDarklyConfig.clientSideID} context={userContext}>
      {children}
    </FeatureFlagProvider>
  );
};

export default LDProviderWrapper;
